import Vue from 'vue';
import VueGoogleMaps from 'gmap-vue';
import { readMeta } from './page';

let installPromise: Promise<void> | null = null;

function mapsPlacesAlreadyLoaded(): boolean {
  return typeof window.google !== 'undefined' && !!window.google.maps && !!window.google.maps.places;
}

export function installGoogleMapsVuePlugin(): Promise<void> {
  if (installPromise) {
    return installPromise;
  }

  const key = readMeta('google_maps');
  if (!key || key === '') {
    installPromise = Promise.resolve();
    return installPromise;
  }

  installPromise = Promise.resolve().then(() => {
    try {
      if (mapsPlacesAlreadyLoaded()) {
        Vue.use(VueGoogleMaps, { installComponents: true });
      } else {
        Vue.use(VueGoogleMaps, {
          load: { key, libraries: ['places'] },
          installComponents: true,
        });
      }
    } catch (error) {
      // Never reject: a Maps failure must not block downstream setup (Braze, GrowthBook).
      console.warn('Failed to install Google Maps Vue plugin:', error);
    }
  });

  return installPromise;
}
